import React from "react";
import { Avatar } from "../avatars/Avatar";
import { AvatarStack } from "../avatars/AvatarStack";
import { TypeSquircle } from "../TypeSquircle";
import { SystemAvatar } from "../avatars/SystemAvatar";

export function Identity({ type, read, actorName, avatarUrl, actors, noteId }) {
  const isStack = Array.isArray(actors) && actors.length > 1;
  const isLegacyNearby = type === "nearby_note" && !noteId;
  return (
    <div className="relative">
      {isLegacyNearby ? (
        <SystemAvatar read={read} />
      ) : isStack ? (
        <AvatarStack actors={actors} overlapClass="-ml-6" />
      ) : (
        <Avatar name={actorName || ""} avatarUrl={avatarUrl} />
      )}
      {!isLegacyNearby && (
        <span className="absolute -bottom-1 -right-1 z-20 pointer-events-none">
          <TypeSquircle type={type} read={read} />
        </span>
      )}
    </div>
  );
}
